<template>
    <div>
        <loading-component :value="loading"/>
        <v-container class="mt-1 pt-0">
            <v-toolbar flat color="white mb-0">
                <v-toolbar-title>Salary Reports</v-toolbar-title>
                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>

                <v-menu
                        lazy
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        full-width
                        :nudge-bottom="-24"
                        max-width="290px"
                        style="margin: 10px"
                >
                    <v-text-field
                            slot="activator"
                            label="Choose month"
                            v-model="date"
                            append-icon="today"
                            readonly
                    ></v-text-field>
                    <v-date-picker
                            v-model="date"
                            type="month"
                            label="Pick Date"
                    />
                </v-menu>

                <v-divider
                        class="mx-2"
                        inset
                        vertical
                ></v-divider>

                <choose-user-multi v-if="enable_employee_choose" v-model="user_id" :multi="false"
                                   style="margin: 10px"
                                   label="Choose employee"></choose-user-multi>
                
                <v-btn v-if="regenrate_option"  color="primary" dark class="mb-2 rgenerate-btn" @click='regenrate_report()'>Regenerate</v-btn>

            </v-toolbar>

            <template>
                <div class="mb-2">
                    <v-card
                            class="d-flex flex-row mb-6"
                            color="grey darken-3"
                            flat
                            tile
                    >
                        <v-card
                                class="pa-3"
                                outline
                                tile
                                style="padding: 5px"
                        >
                            <span class="font-weight-bold">Start Date: </span>
                            <span>{{startDate}}</span>
                        </v-card>
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">End Date: </span>
                            <span>{{endDate}}</span>
                        </v-card>
                    </v-card>
                </div>

                <div class="mb-2">
                    <v-card
                            class="d-flex flex-row mb-6"
                            color="grey darken-3"
                            flat
                            tile
                    >
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">Base Salary: </span>
                            <span>{{salary}}</span>
                        </v-card>
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">Daily Rate: </span>
                            <span>{{dailyRate}}</span>
                        </v-card>
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">Hourly Rate: </span>
                            <span>{{hourlyRate}}</span>
                        </v-card>
                    </v-card>
                </div>

                <div class="mb-2">
                    <v-card
                            class="d-flex flex-row mb-6"
                            color="grey darken-3"
                            flat
                            tile
                    >
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">Remaining Sick Leaves: </span>
                            <span>{{remainingSickLeaves}}</span>
                        </v-card>
                        <v-card
                                class="pa-3"
                                outline
                                tile
                        >
                            <span class="font-weight-bold">Remaining Personal Leaves: </span>
                            <span>{{remainingPersonalLeaves}}</span>
                        </v-card>
                    </v-card>
                </div>


                <div class="mb-2">
                    <v-card
                            class="d-flex flex-row mb-6 text-center"
                            color="grey darken-3"
                            flat
                            tile

                    >
                        <v-card
                                v-for="(reportEntry,index) in detailedReport" :key="index"
                                class="pa-3 text-center"
                                outlined
                                tile
                        >
                            <span class="font-weight-bold">{{index}}: </span>
                            <span :class="reportEntry > 0 ? 'green--text' : 'red--text'">{{reportEntry}}</span>
                        </v-card>
                    </v-card>
                </div>

            </template>
            <v-data-table :headers="headers" :rows-per-page-items="[100]" :items="formattedReport" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.date }}</td>
                    <td class="text-xs-left">
                        <span :class="props.item.OVERTIME > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">{{(props.item.OVERTIME) ? props.item.OVERTIME : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.DISCOUNT > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">
                            {{ props.item.DISCOUNT ? props.item.DISCOUNT : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.LATENESS > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">
                            {{ props.item.LATENESS ? props.item.LATENESS : "-" }}
                        </span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.EXTRA_HOURS > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.EXTRA_HOURS ? props.item.EXTRA_HOURS : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.LEAVE > 0 ? 'green--text' : 'red--text'" class="font-weight-bold">{{ props.item.LEAVE ? props.item.LEAVE : "-" }}</span>
                    </td>
                    <td class="text-xs-left">
                        <span :class="props.item.GENERAL_HOLIDAY > 0 ? 'green--text' : 'red--text'"
                              class="font-weight-bold">{{ props.item.GENERAL_HOLIDAY ? props.item.GENERAL_HOLIDAY : "-" }}</span>
                    </td>
                </template>
            </v-data-table>
        </v-container>
    </div>
</template>

<script>
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";

    export default {
        name: "SalaryReports",
        components: {ChooseUserMulti, ChooseDate, LoadingComponent},
        props: {
            enable_employee_choose: {
                default: true
            }, 
            date_prop: {
                default: null
            },
            user_id_prop: {
                default: null
            },
            regenrate_option: {
                default: true
            }  
        },
        data() {
            return {
                date: this.date_prop,
                report: [],
                detailedReport: [],
                startDate: null,
                endDate: null,
                remainingPersonalLeaves: null,
                remainingSickLeaves: null,
                dailyRate: null,
                hourlyRate: null,
                salary: null,
                user_id: this.user_id_prop,
                salary_report_id: null,
                loading: false,
                headers: [
                    {text: 'Date', value: 'date', sortable: false},
                    {text: 'Overtime', value: 'OVERTIME', sortable: false},
                    {text: 'Discount', value: 'DISCOUNT', sortable: false},
                    {text: 'Lateness', value: 'LATENESS', sortable: false},
                    {text: 'Extra Hours', value: 'EXTRA_HOURS', sortable: false},
                    {text: 'Leave', value: 'LEAVE', sortable: false},
                    {text: 'General Holiday', value: 'GENERAL_HOLIDAY', sortable: false},
                ],
                formattedReport: []
            }
        },
        mounted() { 
            if (!this.enable_employee_choose) {
                this.getData();
            }
        },
        watch: {
            date: {
                handler() {
                    this.getData();
                }
            },
            user_id: {
                handler() {
                    this.getData();
                }
            }
        },
        methods: {
            getData() {
                if(!this.user_id && this.enable_employee_choose) {
                    return;
                }
                this.loading = true;
                const params = new URLSearchParams();
                if (this.date) params.append('date', this.date);
                if (this.user_id) params.append('user_id', this.user_id);
                this.axios.get(this.api.ACTIONS.SALARY_REPORT, {params})
                    .then((res) => {
                            this.salary_report_id = res.data.data.salary_report_id;
                            this.report = res.data.data.report;
                            this.detailedReport = res.data.data.detailed_report;
                            this.startDate = res.data.data.start_date;
                            this.endDate = res.data.data.end_date;
                            this.dailyRate = res.data.data.daily_rate;
                            this.hourlyRate = res.data.data.hourly_rate;
                            this.salary = res.data.data.salary;
                            this.remainingSickLeaves = res.data.data.remaining_sick_leaves;
                            this.remainingPersonalLeaves = res.data.data.remaining_personal_leaves;
                            this.formatReport();
                        }
                    ).catch(
                    ({response}) => {
                        if (response && response.data && response.data.message){
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                            this.formattedReport = [];
                        }    
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Error Happened", 'red');
                            console.log(response);
                        }

                    }
                ).finally(() => {
                    this.loading = false;
                });
            },
            formatReport() {
                this.formattedReport = Object.values(this.report);
            },

            regenrate_report(){
                if(!this.user_id && this.enable_employee_choose) {
                    return;
                }
                this.loading = true;
                const params = new URLSearchParams();
                if (this.salary_report_id) params.append('salary_report_id', this.salary_report_id);
                this.axios.get(this.api.ACTIONS.REGENERATE_REPORT, {params})
                    .then((res) => {
                            this.report = res.data.data.report;
                            this.detailedReport = res.data.data.detailed_report;
                            this.startDate = res.data.data.start_date;
                            this.endDate = res.data.data.end_date;
                            this.dailyRate = res.data.data.daily_rate;
                            this.hourlyRate = res.data.data.hourly_rate;
                            this.salary = res.data.data.salary;
                            this.remainingSickLeaves = res.data.data.remaining_sick_leaves;
                            this.remainingPersonalLeaves = res.data.data.remaining_personal_leaves;
                            this.formatReport();
                        }
                    ).catch(
                    ({response}) => {
                        if (response && response.data && response.data.message){
                            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
                        }    
                        else {
                            window.getApp.$emit('SHOW_TOAST', "Error Happened", 'red');
                            console.log(response);
                        }

                    }
                ).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>
    .rgenerate-btn{
        margin-left: auto;
    }
</style>
